import arraySample from './_arraySample.js';
import values from './values.js';

/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return arraySample(values(collection));
}

export default baseSample;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/_baseSample.js
// module id = 1194
// module chunks = 0